import VideoHoc from "@/components/business/VideoHoc/VideoHoc";
import { IMaterialFile } from "@/stores/mixCutDetailStore/type";
import { IconClose } from "@arco-design/web-react/icon";
import cutImg from "@/assets/cut-mix-detail/cut.png";
import cutted from "@/assets/cut-mix-detail/cutted.png";
import useMaterialPlayInfo from "@/useStore/mixCutDetail/useMaterialPlayInfo";
import "./VideoItemBlock.less";
import { Popconfirm, Message } from "@arco-design/web-react";
import { observer } from "mobx-react";
import ImgMemo from "../../../ImgMemo/ImgMemo";
import getText from "@/assets/cut-mix-detail/text-analysis-min.png";
import hasText from "@/assets/cut-mix-detail/textHasanalysis-min.png";
import LoadingGIF from "@/components/UI/LoadingGIF";
import { useContext, useEffect, useRef, useState } from "react";
import { getBindVideoMaterialStatus } from "@/services/mixCutDetail/mixCutDetail";
import { useParams } from "react-router-dom";
import CutIcon from "@/assets/cut-mix-detail/cut-icon.png";
import Cuted from "@/assets/cut-mix-detail/cuted.png";
import ClipDrawer from "@/components/business/ClipDrawer";
import { getSimpleMedia } from "@/services/createSpace/graphQ/getSimpleMedia";
import ConfigStore from "@/stores/mixedConfig";
import useMixCutDetailSave from "@/useStore/mixCutDetail/useMixCutDetailSave";

export interface IVideoHocProps {
  data: IMaterialFile;
  handleCloseBtnClick: (id: string) => void;
  handleEditBtnClick: () => void;
  style: React.CSSProperties;
  isCropped?: boolean;
  duration: string;
  toGetText?: (id: string) => void;
  onTextAnalysis?: (data: object) => void;
  showAnalysis?: boolean;
  analysisId: string | number;
  videoStatusList: any[];
  sencesIndex: number;
}

const VideoItemBlock: React.FC<IVideoHocProps> = observer((props) => {
  const {
    duration,
    data,
    handleCloseBtnClick,
    style,
    handleEditBtnClick,
    isCropped = false,
    onTextAnalysis,
    toGetText,
    showAnalysis = false,
    analysisId,
    videoStatusList,
    sencesIndex,
  } = props;
  const { toIdFindMaterialItem } = useMaterialPlayInfo();
  const { handleSaveMixCutDetailSave } = useMixCutDetailSave();
  const [showLoading, setShowLoading] = useState(false);
  const clipDrawerRef = useRef(null);
  const [checkId, setCheckId] = useState(null);
  const showIcon = (id) => {
    if (videoStatusList && videoStatusList.length > 0) {
      return videoStatusList.find((item) => item.id === id)?.status === 1;
    }
  };
  return (
    <VideoHoc
      type={data.type}
      disMuted={true}
      url={
        data.type === 1
          ? toIdFindMaterialItem(data?.id)?.url
          : toIdFindMaterialItem(data?.id)?.cover
      }
      style={{ ...style, position: "relative" }}
    >
      <div className="video-group-video-container">
        {showAnalysis && analysisId === data.id && showLoading && (
          <div className="loading-img">
            <LoadingGIF />
          </div>
        )}
        <Popconfirm
          focusLock
          title="删除提示！"
          content="确认删除此视频素材吗"
          onOk={() => {
            handleCloseBtnClick(data.id);
          }}
          onCancel={() => {
            console.log("取消");
          }}
        >
          <div className="video-close-btn">
            <IconClose className="close-btn" />
          </div>
        </Popconfirm>
        <ImgMemo
          key={toIdFindMaterialItem(data.id)?.cover}
          src={toIdFindMaterialItem(data.id)?.cover}
          alt=""
          className="video-item-cover-img"
        />
        {/*
        {isCropped ? (
          <img
            src={cutted}
            alt=""
            className="video-item-cutted"
            onClick={() => {
              handleEditBtnClick();
            }}
          />
        ) : (
          <img
            src={cutImg}
            alt=""
            className="video-item-edit"
            onClick={() => {
              handleEditBtnClick();
            }}
          />
        )} */}
        <div className="duration-tip">{duration}</div>
        {data.is_cropped ? (
          <img
            onClick={async (e) => {
              e.stopPropagation();
              setCheckId(data.id);
              const res = await getSimpleMedia(Number(data.id));
              console.log({
                ...res,
                // start: data.start,
                // duration: data.duration,
                offsetL: data.offsetL,
                offsetR: data.offsetR,
              });
              clipDrawerRef.current.open({
                ...res,
                clip: {
                  // start: data.start,
                  // duration: data.duration,
                  offsetL: data.offsetL,
                  offsetR: data.offsetR,
                  end: (data as any).end,
                },
              });
            }}
            className="cuted"
            src={Cuted}
          />
        ) : (
          Number(data.type) === 1 && (
            <img
              onClick={async (e) => {
                e.stopPropagation();
                setCheckId(data.id);
                const res = await getSimpleMedia(Number(data.id));
                clipDrawerRef.current.open(res);
              }}
              className="cut-img"
              src={CutIcon}
            />
          )
        )}
        {showIcon(data.id) ? (
          <img
            onClick={() => {
              onTextAnalysis(data);
            }}
            className="getText"
            src={hasText}
          />
        ) : (
          <Popconfirm
            focusLock
            title="提示！"
            content="是否解析并提取视频中的台词？"
            onOk={() => {
              setShowLoading(true);
              onTextAnalysis(data);
            }}
            okText="提取台词"
            onCancel={() => {
              console.log("取消");
            }}
          >
            {data.type !== 3 && <img className="getText" src={getText} />}
          </Popconfirm>
        )}
      </div>
      <ClipDrawer
        ref={clipDrawerRef}
        mark
        onOk={(v) => {
          console.log("crop ok", v);
          Message.success("保存成功");
          ConfigStore.scenes[sencesIndex].materials.map((item) => {
            if (item.id === checkId) {
              item.start = v.start;
              item.duration = v.duration;
              item.is_cropped = v.cropped;
              item.offsetL = v.offsetL;
              item.offsetR = v.offsetR;
              (item as any).end = v.end;
            }
            return item;
          });
          handleSaveMixCutDetailSave();
        }}
      />
    </VideoHoc>
  );
});

export default VideoItemBlock;
